<template>
	<v-container class="my-9">
		<v-row class="mb-4">
			<v-col cols md="12">
				<h2 class="display-2 mt-4">
					Reto de Altares : <strong>Representaciones de México</strong>
				</h2>
				<v-divider class="dorado mt-4" />
			</v-col>
		</v-row>

		<v-row>
			<v-col v-for="(item, i) in getAltars.data" :key="i" md="4">
				<v-img
					:src="
						item.photoCompletion
							? item.photoCompletion[0].content
							: 'https://cdn.vuetifyjs.com/images/parallax/material2.jpg'
					"
					:lazy-src="thumb_convert(item.photoCompletion[0].content)"
					aspect-ratio="1.35"
					class="elevation-4 rounded">
					<div class="fill-height bottom-gradient d-flex align-end">
						<div
							class="text-center dorado-obscuro py-2 px-3"
							style="width: 100%">
							<v-row>
								<v-col md="3" class="d-flex align-center justify-center">
									<v-btn
										dark
										rounded
										class="rojo"
										:href="`/vinculacion/concursos/altares/rme/folio/${item.uuid}`">
										<v-icon left> mdi-thumb-up </v-icon>
										{{ item.rme_votes.length }}
									</v-btn>
								</v-col>
								<v-col md="9">
									<div
										style="width: 90%"
										class="text-uppercase white--text font-weight-bold block text-truncate">
										{{ item.fullName ? item.fullName : "Sin Nombre" }}
										<br />
										<small class="white--text font-weight-regular">
											{{ item.residenceCountry }}
										</small>
									</div>
								</v-col>
							</v-row>
						</div>
					</div>
				</v-img>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<PaginationComponent
					v-if="getAltars.meta"
					:page="getAltars.meta.pagination.page"
					:page-size="getAltars.meta.pagination.pageSize"
					:page-count="getAltars.meta.pagination.pageCount"
					:total="getAltars.meta.pagination.total"
					category="rme"></PaginationComponent>
			</v-col>
		</v-row>

		<v-row>
			<v-col>
				<SeoComponent
					seoTitle="Reto de Altares, Comunidades Mexicanas"
					seoDescription="Te invitamos a participar en la Octava Edición del Reto de Altares de Día de Muertos 2024, bajo el lema 'La Ofrenda: Cultivando memoria, construyendo puentes'."
					:seoCanonical="selfPage"
					seoImage="https://api-vinculacion.k0s.ime.red/uploads/reto_de_altares_59da1f326f.png" />
			</v-col>
		</v-row>

		<!-- <v-row>
			<v-col>
				<pre>{{ getAltars.data }}</pre>
			</v-col>
		</v-row> -->
	</v-container>
</template>

<script>
	import wsAltarChallenge from "@/services/altares/api-altar-challenge";
	import PaginationComponent from "@/components/global/_PaginationAltars.vue";
	import SeoComponent from "@/components/global/Seo.vue";

	export default {
		name: "AltarsComunidadesView",

		components: { PaginationComponent, SeoComponent },

		data: () => ({
			getAltars: {},
		}),

		computed: {
			setUuid() {
				var cookie = this.dataCookie[2];
				return cookie;
			},

			thisPagination() {
				let page1 = this.$route.params.page;
				let page2 = Number(page1);
				let page = !page2 ? 1 : page2;
				//console.log("🚀 ~ thisPagination ~ page:", page);
				return page;
			},

			selfPage() {
				let self = process.env.VUE_APP_BASE_URL + this.$route.path;
				return self;
			},
		},

		mounted() {
			this.loadAltars("rme_cdi", 15, this.thisPagination);
		},

		methods: {
			loadAltars(category, pageSize, page) {
				wsAltarChallenge.getAltarsByCategory(category, pageSize, page).then(
					(response) => {
						this.getAltars = response.data;
					},
					(error) => {
						this.getAltars =
							(error.response && error.response) ||
							error.message ||
							error.toString();
					}
				);
			},

			thumb_convert(src) {
				let image = src.replaceAll("/thumbnail_ALTARES_2024", "/ALTARES_2024");
				return image;
			},
		},
	};
</script>

<style scoped>
	.bottom-gradient {
		background-image: linear-gradient(
			to top,
			rgba(0, 0, 0, 0.75) 0%,
			transparent 80%
		);
	}

	.repeating-gradient {
		background-image: repeating-linear-gradient(
			-45deg,
			rgba(255, 0, 0, 0.25),
			rgba(255, 0, 0, 0.25) 5px,
			rgba(0, 0, 255, 0.25) 5px,
			rgba(0, 0, 255, 0.25) 10px
		);
	}
</style>
